/** Horizontal inset for leftTop slot content (matches TopMapToolbar padding). */
export const topBarInsetClass = 'w-full px-3 md:px-6';
